import { Button } from "@/components/ui/button";
import { Save, X } from "lucide-react";

interface BulkEditFooterProps {
  willUpdateCount: number;
  isLoading: boolean;
  showProgressModal: boolean;
  updateButtonLabel: string;
  onClose: () => void;
  onSave: () => void;
  onCloseProgress: () => void;
}

export function BulkEditFooter({
  willUpdateCount,
  isLoading,
  showProgressModal,
  updateButtonLabel,
  onClose,
  onSave,
  onCloseProgress,
}: BulkEditFooterProps) {
  return (
    <div className="flex items-center justify-between pt-4 border-t">
      <div className="text-sm text-gray-600 dark:text-gray-400">Will update {willUpdateCount} items</div>
      <div className="flex items-center gap-2">
        <Button variant="outline" onClick={onClose} disabled={isLoading}>
          <X className="h-4 w-4 mr-2" />
          Cancel
        </Button>
        <Button onClick={onSave} disabled={isLoading} className="gap-2">
          {isLoading ? (
            <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <Save className="h-4 w-4" />
          )}
          {updateButtonLabel}
        </Button>
        {showProgressModal && (
          <Button variant="outline" onClick={onCloseProgress} className="gap-2">
            <X className="h-4 w-4" />
            Close Progress
          </Button>
        )}
      </div>
    </div>
  );
}
